
export enum AmpEventSourceTypeDo {
  DO = 'DiscoverOrg'
}
